<template>
  <b-container class="d-flex flex-column h-100" fluid>
    <div
      class="pagetitle-container d-flex justify-content-between align-items-center"
    >
      <div class="page-title">
        <h2>{{ name }}</h2>
      </div>
      <div class="d-flex flex-grow-1">
        <input-filter
          ref="filter"
          :filters="table.filter"
          :options="filterOptions"
          @onReset="resetFilter"
          @onSearch="search"
        />
      </div>
    </div>
    <div ref="scroll" v-bar class="bar-out">
      <div>
        <file-manager
          ref="filemanager"
          :data="{ project_id: $route.params.id }"
          :table="table"
          :url="routes"
        >
          <template slot="actions" slot-scope="{ props }">
            <b-dropdown-item
              @click.prevent="openNoteModal(props.row.id, props.row.note)"
            >
              <icon class="icon-fw mr-2" name="pencil-alt" scale="0.75" />
              Poznámky
            </b-dropdown-item>
          </template>
        </file-manager>
      </div>
    </div>
    <b-modal
      id="addNote"
      ref="addNote"
      cancel-title="Zrušiť"
      lazy
      no-enforce-focus
      ok-title="Uložiť"
      size="sm"
      title="Poznámky"
      @hidden="
        note = ''
        docId = null
      "
      @ok="editNote"
    >
      <textarea
        v-if="$root.user.isAdmin"
        v-model="note"
        class="form-control"
        placeholder="žiadne poznámky (kliknutím pridajte)"
        rows="4"
        wrap="soft"
      />
    </b-modal>
  </b-container>
</template>
<script>
import InputFilter from '@/components/InputFilter'
import FileManager from '@/components/filemanager/List'

export default {
  components: { InputFilter, FileManager },
  data() {
    return {
      table: {
        loading: false,
        columns: [
          {
            key: 'actions',
            label: '',
            thClass: 'th-shrink',
          },
          {
            key: 'name',
            label: 'Názov',
            tdClass: 'td-link',
            sortable: true,
            sortableKey: 'project_docs.name',
            searchable: true,
          },
          {
            key: 'updated_at',
            label: 'Upravené',
            formatter: (value) =>
              value ? this.$options.filters.formatDateTime(value) : '-',
            sortable: true,
            class: 'text-right',
          },
          {
            key: 'size',
            label: 'Veľkosť',
            formatter: (value) =>
              value ? this.$options.filters.fileSize(value) : '-',
            sortable: true,
            class: 'text-right',
          },
          {
            key: 'created_by',
            label: 'Vytvoril',
            formatter: (value, key, item) =>
              item.lastname
                ? this.$root.user.isAdmin
                  ? item.firstname + ' ' + item.lastname
                  : 'ESM'
                : '-',
            sortable: true,
          },
        ],
        sortBy: 'name',
        searchable: false,
      },
      filterOptions: {
        placeholder: 'Filtrovanie a hľadanie...',
      },
      routes: {
        explorer: `projects/${this.$route.params.id}/get_document_tree`,
        show: `projects/${this.$route.params.id}/documents`,
        open: '/api/projects/open_file/',
        download: '/api/projects/download_file/',
        rename: 'projects/doc/rename',
        move: 'projects/doc/move',
        upload: 'projects/uploadFiles',
        delete: 'projects/doc/delete',
        createFolder: 'projects/create_folder',
      },
      name: '',
      note: '',
      docId: null,
    }
  },
  created: function () {
    this.getProject()
  },
  methods: {
    search() {
      this.$refs.filemanager.$refs.table.searchVal = this.$refs.filter.value
      this.$nextTick(() => {
        this.$refs.filemanager.$refs.table.search()
      })
    },
    resetFilter() {
      this.$refs.filemanager.$refs.table.reset()
    },
    openNoteModal(id, note) {
      this.$refs.addNote.show()
      this.docId = id
      this.note = note
    },
    editNote() {
      this.$api
        .post('projects/save_note', {
          id: this.docId,
          note: this.note,
        })
        .then(() => {
          this.resetFilter()
        })
    },
    getProject() {
      this.$api.get(`projects/${this.$route.params.id}/get`).then((res) => {
        this.name = res.data.name
      })
    },
  },
}
</script>
